import { defineQueryKeyCreator } from "@app/common/utils/queryUtils";

const define = defineQueryKeyCreator("propertyGroups");

export const QueryKeys = {
    PropertyGroupItem: define("property-group"),
    PropertyGroupMap: define("property-group-map"),
} as const;
